import { useEffect, useState } from 'react';
import { getSSToken } from '../../../utils/token';
import { AvatarDetail } from '../types';

export const useAvatarDetail = (avatarId: string | null, urlBase: string) => {
    const [detail, setDetail] = useState<AvatarDetail | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!avatarId) {
            setDetail(null);
            setError(null);
            return;
        }

        const fetchDetail = async () => {
            setLoading(true);
            setError(null);

            try {
                const token = await getSSToken();
                if (!token) {
                    setError('No authentication token available');
                    setLoading(false);
                    return;
                }

                const detailUrl = `${urlBase}?page=1&itemsPerPage=1&avatarId=${encodeURIComponent(avatarId)}`;
                const response = await fetch(detailUrl, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`.trim(),
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP ${response.status}`);
                }

                const result = await response.json();
                if (result && result['hydra:member'] && result['hydra:member'].length > 0) {
                    setDetail(result['hydra:member'][0]);
                } else {
                    setDetail(null);
                }
            } catch (e: any) {
                setError(e?.message || 'Unknown error');
            } finally {
                setLoading(false);
            }
        };

        fetchDetail();
    }, [avatarId, urlBase]);

    return { detail, loading, error };
};
